module.exports = __webpack_public_path__ + "static/media/food4.b221851e.jpeg";